export const makeTopLevelElement = (type, children = []) => ({
    type,
    children,
    flattenedMdastPath: undefined,
    flattenedMdastAncestors: undefined,
    mdastNode: undefined,
    parentMdastNode: undefined,
});
export const makeLineElement = (text) => ({
    type: 'line',
    children: [
        {
            text,
        },
    ],
});
//# sourceMappingURL=element-factories.js.map